import React from 'react';

import { FeaturesHighClass, FeaturesTopClass } from '@travel/icons/features';
import { Furusato, Sustainability } from '@travel/icons/service';
import { cx } from '@travel/utils';

import { PREMIUM_TYPE } from '../../constants';

import styles from './featureBadges.module.scss';

import type { BadgeLabels, ProviderFeatures } from '../../types';

type Props = ProviderFeatures & BadgeLabels;

export default function FeatureBadges(props: Props) {
  const { premiumType, sustainability, isHometownTaxApplicable, badges } = props;

  return (
    <div className={styles.featureBadges}>
      {premiumType === PREMIUM_TYPE.Deluxe ? (
        <FeaturesTopClass />
      ) : premiumType === PREMIUM_TYPE.Premium ? (
        <FeaturesHighClass />
      ) : null}
      {sustainability.isSustainable && (
        <span className={cx(styles.badge, styles.sustainableLabel)}>
          <Sustainability size={14} color="cilantro" />
          {badges.sustainableBadge}
        </span>
      )}
      {isHometownTaxApplicable && (
        <span
          className={cx(styles.badge, styles.hometownTaxLabel)}
          data-testid="providerCommonHeader-hometownTaxBadge"
        >
          <Furusato size={14} className={styles.hometownTaxIcon} />
          {badges.hometownTaxBadge}
        </span>
      )}
    </div>
  );
}
